import React from 'react'
import classNames from 'classnames'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { twMerge } from 'tailwind-merge'

export const Chip = ({
  children,
  className = '',
  isDeletable = false,
  state = null,
  onClick,
  ...props
}) => {

  const classes = [
    'group',
    'rounded-full',
    'border',
    'px-2',
    'py-0.5',
    'font-medium',
    'space-x-1',
  ];

  if (onClick || isDeletable) {
    classes.push('cursor-pointer')
  }

  classes.push({
    '2xl': 'text-2xl',
    xl: 'text-xl',
    lg: 'text-lg',
    base: 'text-base',
    sm: 'text-sm',
    xs: 'text-xs',
  }[props.size] ?? 'text-xs') // Default to xs

  classes.push({
    success: 'bg-positive border-positive text-white',
    error: 'bg-negative border-negative text-white',
    warning: 'bg-warning border-warning text-white',
    info: 'bg-primary border-primary text-white'
  }[state] || 'bg-gray-100 border-gray-100 text-gray-600') // Default to 'gray'/plain

  return (
    <span
      {...props}
      className={classNames(twMerge(classes.map((c) => c.split(' ')).flat(), className))}
      onClick={onClick}
    >
      <span>{ children }</span>

      { isDeletable && (
        <button className="hover:rotate-45 duration-100 transition-transform">
          <FontAwesomeIcon icon="fa-solid fa-times" />
        </button>
      )}
    </span>
  )
}

export default Chip

